const QuestionTypes = {
  WHERE: "where",
  WHEN: "when",
  OPTIONS: "options",
  CONTACT: "contact",
  CONFIRM: "confirm",
}
export default QuestionTypes;